import { tokens } from '@welbe/web-design-system'
import styled from 'styled-components'

export const Wrapper = styled.div`
	display: flex;
	align-items: center;
	flex-direction: column;
	padding: 1rem;
	height: 100%;
	background: white;

	.resend-button {
		color: ${tokens.color_primary};
		text-decoration: underline;
		font-weight: 600;
	}
`

export const Container = styled.div`
	display: flex;
	gap: 8px;
	justify-content: center;
	margin: 2rem 0;
	flex-wrap: wrap;

	@media (max-width: 648px) {
		gap: 12px;
	}
`

export const InputEmail = styled.input`
	margin: 16px 0;
	border: none;
	width: 268px;
	border-bottom: 1px solid ${tokens.color_primary};
	color: ${tokens.color_primary};
	font-size: 18px;
	font-style: normal;
	font-weight: 600;
	font-family: ${tokens.font_family_primary};
	text-align: center;

	@media (min-width: 648px) {
		width: 350px;
	}
`

export const InputField = styled.input`
	width: 37px;
	height: 47px;
	border: 2px solid #e2e8f0;
	border-radius: 8px;
	font-size: 20px;
	font-weight: 500;
	font-family: ${tokens.font_family_primary};
	text-align: center;
	color: ${tokens.color_gray_dark};
	transition: all 0.2s ease;

	&:focus {
		border-color: ${tokens.color_primary};
		box-shadow: 0 0 0 3px rgba(49, 130, 206, 0.3);
		outline: none;
	}
`

export const Title = styled.p`
	color: ${tokens.color_gray_dark};
	text-align: center;
	font-size: 16px;
	font-style: normal;
	font-weight: 500;
	margin-bottom: 16px;

	@media (max-width: 648px) {
		font-size: 1.5rem;
	}
`

export const SubTitle = styled.p`
	color: ${tokens.color_gray_dark};
	font-family: ${tokens.font_family_primary};
	text-align: center;
	font-size: 12px;
	font-style: normal;
	font-weight: 500;
	line-height: 18px;
	width: 268px;
`
